import { USER_DIRECTORY_BABY } from 'mk/autogenerated/translations/UsersDirectory.b238fbc12a0a8f08c36dd9fc010d6656'
import { UsersDirectoryForm } from 'mk2/apps/users/components/UsersDirectoryForm';
import { Props } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectoryPage';
import React from 'react';

export default class UsersDirectory extends React.Component<Props> {

    public render() {
        const {
            initialValues, currentValues, onSearch, usersStats, isMobile, hasMore,
        } = this.props;

        return (
            <UsersDirectoryForm
                initialValues={initialValues}
                currentValues={currentValues}
                onSearch={onSearch}
                usersStats={usersStats}
                isMobile={isMobile}
                hasMore={hasMore}
            />
        );
    }
}
